(function () {
    'use strict';

    angular
        .module('app')
        .controller('externalController', externalController);

    function externalController($sce, menuService) {
        var vm = this;

        init();

        function init() {

            // 紀錄這次進入的 menu No 到 session storage 中
            // 如果需要登入就會被導到登入頁
            // 登入後就會依照這個參數導到該頁面中
            //sessionStorage.setItem('menuNo', getMenuQueryString());

            let langSerilNo = 1;
            if (sessionStorage.getItem('langCode')) {
                langSerilNo = sessionStorage.getItem('langCode');
            }

            menuService.getInformationBySerilNo(getMenuQueryString(), langSerilNo).then(function (data) {

                let isEmbed = data.data.target === 2 /*崁入式窗*/ ;
                if (isEmbed) {
                    menuService.generateUrl(data.data, sessionStorage.getItem('token'));

                    vm.url = $sce.trustAsResourceUrl(data.data.url);
                } else {
                    // includ token transfer flow
                    menuService.redirectUrl(data.data);
                }
            });

        }

        // function getCurrentLangSerilNo(){
        //       if (sessionStorage.getItem('langCode')) {
        //         langSerilNo = sessionStorage.getItem('langCode');
        //     }
        // }
    }
})();